<template>
  <NoteTable
    :loading="isLoading"
    :rows="noteList"
    :columns="columns"
    :line-numbers="true"
    :sort="sort"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    @delete="confirmRemoval"
    @onFilter="onFilter"
    @onPageChange="onPageChange"
    @onPerPageChange="onPerPageChange"
    @onSortChange="onSortChange"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { NOTE_LIST_REQUEST } from '@/store/actions/note';
import NoteTable from '@/components/note/NoteTable';
import dataListMixin from '@/mixins/dataListMixin';

export default {
  mixins: [dataListMixin],

  props: {
    officer: Object,
  },

  components: { NoteTable },

  data() {
    return {
      storeActionListRequest: NOTE_LIST_REQUEST,
      columns: [
        {
          label: this.$t('text.loanNumber'),
          field: 'loanId',
          filterable: true,
        },
        {
          label: this.$t('text.firstName'),
          field: 'firstName',
          filterable: true,
          disabled: true,
        },
        {
          label: this.$t('text.customer'),
          field: 'user',
        },
        {
          label: this.$t('text.loanAmount'),
          field: 'amount',
        },
        {
          label: this.$t('text.haveDeadline'),
          field: 'reminderDate',
        },
        {
          label: this.$t('text.description'),
          field: 'description',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['noteList', 'noteMeta', 'noteListStatus']),
    isLoading() {
      return this.noteListStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters[`filter[officerId]`] = this.officer.id;
    },

    setPaginationValues() {
      this.totalRecords = this.noteMeta ? this.noteMeta.total : 1;
      this.page = this.noteMeta.currentPage;
      this.totalPage = this.noteMeta.lastPage;
    },
  },
};
</script>
